module.exports = __webpack_public_path__ + "static/media/inside_living.a0bb15bb.jpeg";